import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Context } from "..";
import { observer } from "mobx-react-lite";
import Placeholder from "../components/Placeholder";
import UserTable from "../components/UserTable";
import { Link } from "react-router-dom";

const ONLY_FAKE_LS_KEY = "users.onlyFake";

const UsersPage = () => {
  const { store } = useContext(Context);

  const [onlyFake, setOnlyFake] = useState<boolean>(() => {
    try {
      return localStorage.getItem(ONLY_FAKE_LS_KEY) === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (localStorage.getItem("token")) {
      store.checkAuth();
    }
    store.fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(ONLY_FAKE_LS_KEY, String(onlyFake));
    } catch {
      /* ignore */
    }
  }, [onlyFake]);

  const deleteOneUser = async (id: string) => {
    store.deleteUser(id);
  };

  const filteredUsers = useMemo(() => {
    const all = store.users || [];
    if (!onlyFake) return all;

    return all.filter(
      (u) =>
        typeof u?.email === "string" &&
        u.email.toLowerCase().startsWith("fake.")
    );
  }, [onlyFake, store.users]);

  if (store.isLoading) {
    return (
      <div className="App">
        <div className="container">
          <h2>Список сотрудников</h2>
          <table id="users-table" className="table table-striped">
            <tbody>
              <tr>
                <th>Фамилия</th>
                <th>Имя</th>
                <th>Email</th>
                <th>Управление</th>
              </tr>
              <tr>
                <td><Placeholder /></td>
                <td><Placeholder /></td>
                <td><Placeholder /></td>
                <td><Placeholder /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="container">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h2>Список сотрудников</h2>
            <p className="mb-0">
              Показано: {filteredUsers.length} / Всего: {store.users.length}
            </p>
          </div>

          {/* Toggle */}
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="onlyFakeSwitch"
              checked={onlyFake}
              onChange={(e) => setOnlyFake(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="onlyFakeSwitch">
            Только Работники (склада или водители)
            </label>
          </div>
        </div>

        <hr />

        <UserTable
          admin={store?.user}
          deleteUser={deleteOneUser}
          users={filteredUsers}
        />

        <Link className="btn btn-primary mb-5" to="/users/createUsers">
          Импортировать CSV
        </Link>
      </div>
    </div>
  );
};

export default observer(UsersPage);
